import { makeAutoObservable } from 'mobx';
import React from 'react';
import { Common } from 'src/AppState/Common';
import { ToasterState } from 'src/AppState/ToasterState';

type OnDropType = (files: File[]) => void;

export class DnDAreaState {
    public isFileOver: boolean = false;
    private allowedMimeTypes: string[];
    private onDropCallback: OnDropType;
    private common?: Common;

    public constructor(onDropCallback: OnDropType, allowedMimeTypes: string[] = [], common?: Common) {
        this.onDropCallback = onDropCallback;
        this.allowedMimeTypes = allowedMimeTypes;
        this.common = common;
        makeAutoObservable(this);
    }

    public highlightArea = (event: React.DragEvent): void => {
        this.preventDefaults(event);
        this.setIsFileOver(true);
    };

    public restoreArea = (event: React.DragEvent): void => {
        this.preventDefaults(event);
        this.setIsFileOver(false);
    };

    public setIsFileOver = (value: boolean): void => {
        this.isFileOver = value;
    };

    public handleDrop = (event: React.DragEvent): void => {
        this.preventDefaults(event);
        this.restoreArea(event);

        const files = Array.from(event.dataTransfer.files);
        if (files.length > 0) {
            if (this.areFileTypesAllowed(files)) {
                this.onDropCallback(files);
            } else if (this.common instanceof Common) {
                ToasterState.get(this.common).setToast({
                    variant: 'error',
                    title: 'Error!',
                    message: `Wrong file type. Only ${this.allowedMimeTypes.toString()} files are allowed.`,
                });
            } else {
                throw new Error('Wrong file type');
            }
        }
    };

    private areFileTypesAllowed = (files: File[] = []): boolean => {
        let allowed = true;
        for (const file of files) {
            const mimeType = file.type;
            if (!this.allowedMimeTypes.includes(mimeType)) {
                allowed = false;
                break;
            }
        }
        return allowed;
    };

    private preventDefaults = (event: React.DragEvent): void => {
        event.preventDefault();
        event.stopPropagation();
    };
}
